// configs/menuConfig.js
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import TravelExploreIcon from "@mui/icons-material/TravelExplore";
import PeopleIcon from "@mui/icons-material/People";
import PinDropIcon from "@mui/icons-material/PinDrop";
import DevicesIcon from "@mui/icons-material/Devices";
import AssessmentIcon from "@mui/icons-material/Assessment";
import PolylineIcon from "@mui/icons-material/Polyline";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import Inventory2Icon from "@mui/icons-material/Inventory2";

// Tenant bazında menu konfigürasyonları
export const TENANT_MENU_CONFIGS = {
  VAOYS: [
    // {
    //   text: "menu.dashboard",
    //   icon: <HomeRoundedIcon />,
    //   path: "/dashboard",
    // },
    // {
    //   text: "menu.nodeDetail",
    //   icon: <PointOfSaleIcon />,
    //   path: "/vending-machines",
    // },
    // {
    //   text: "menu.regions",
    //   icon: <TravelExploreIcon />,
    //   path: "/regions",
    // },
    // {
    //   text: "menu.vending-definitions", // Varsayılan tenant için - Otomatlar
    //   icon: <PinDropIcon />,
    //   path: "/vending-definitions",
    // },
    // {
    //   text: "menu.users",
    //   icon: <PeopleIcon />,
    //   path: "/users",
    //   requiresAdmin: true,
    // },
    // {
    //   text: "menu.devices",
    //   icon: <DevicesIcon />,
    //   path: "/devices",
    // },
    // {
    //   text: "menu.adminConfigurations",
    //   icon: <AdminPanelSettingsIcon />,
    //   path: "/admin-configurations",
    //   requiresAdmin: true,
    // },
    {
      text: "menu.dashboard",
      icon: <HomeRoundedIcon />,
      path: "/dashboard",
    },
    {
      text: "menu.nodeDetail",
      icon: <PointOfSaleIcon />,
      path: "/vending-machines",
    },
    {
      text: "menu.regions",
      icon: <TravelExploreIcon />,
      path: "/regions",
    },
    {
      text: "menu.vending-definitions",
      icon: <PinDropIcon />,
      path: "/vending-definitions",
    },
    {
      text: "menu.users",
      icon: <PeopleIcon />,
      path: "/users",
      requiresAdmin: true,
    },
    {
      text: "menu.devices",
      icon: <DevicesIcon />,
      path: "/devices",
    },
    {
      text: "menu.reports",
      icon: <AssessmentIcon />,
      path: "/reports",
    },
    // {
    //   text: "menu.stocks",
    //   icon: <Inventory2Icon />,
    //   path: "/stock-management",
    // },
    {
      text: "menu.adminConfigurations",
      icon: <AdminPanelSettingsIcon />,
      path: "/admin-configurations",
      requiresAdmin: true,
    },
  ],

  VENDAI: [
    {
      text: "menu.dashboard",
      icon: <HomeRoundedIcon />,
      path: "/dashboard",
    },
    {
      text: "menu.nodeDetail",
      icon: <PointOfSaleIcon />,
      path: "/vending-machines",
    },
    {
      text: "menu.regions",
      icon: <TravelExploreIcon />,
      path: "/regions",
    },
    {
      text: "menu.vending-definitions",
      icon: <PinDropIcon />,
      path: "/vending-definitions",
    },
    {
      text: "menu.users",
      icon: <PeopleIcon />,
      path: "/users",
      requiresAdmin: true,
    },
    {
      text: "menu.devices",
      icon: <DevicesIcon />,
      path: "/devices",
    },
    {
      text: "menu.reports",
      icon: <AssessmentIcon />,
      path: "/reports",
    },
    {
      text: "menu.stocks",
      icon: <Inventory2Icon />,
      path: "/stock-management",
    },
    {
      text: "menu.adminConfigurations",
      icon: <AdminPanelSettingsIcon />,
      path: "/admin-configurations",
      requiresAdmin: true,
    },
  ],

  WWMS: [
    {
      text: "menu.dashboard",
      icon: <HomeRoundedIcon />,
      path: "/dashboard",
    },
    {
      text: "menu.regions",
      icon: <TravelExploreIcon />,
      path: "/regions",
    },
    {
      text: "menu.places", // Varsayılan tenant için - Yerler
      icon: <PinDropIcon />,
      path: "/places",
    },
    {
      text: "menu.wwmsdef",
      icon: <PolylineIcon />,
      path: "/node-detail",
    },
    {
      text: "menu.users",
      icon: <PeopleIcon />,
      path: "/users",
      requiresAdmin: true,
    },
    {
      text: "menu.devices",
      icon: <DevicesIcon />,
      path: "/devices",
    },
    {
      text: "menu.adminConfigurations",
      icon: <AdminPanelSettingsIcon />,
      path: "/admin-configurations",
      requiresAdmin: true,
    },
  ],

  UITEST: [
    {
      text: "menu.dashboard",
      icon: <HomeRoundedIcon />,
      path: "/dashboard",
    },
    {
      text: "menu.nodeDetail",
      icon: <PointOfSaleIcon />,
      path: "/vending-machines",
    },
    {
      text: "menu.regions",
      icon: <TravelExploreIcon />,
      path: "/regions",
    },
    {
      text: "menu.vending-definitions",
      icon: <PinDropIcon />,
      path: "/vending-definitions",
    },
    {
      text: "menu.users",
      icon: <PeopleIcon />,
      path: "/users",
      requiresAdmin: true,
    },
    {
      text: "menu.devices",
      icon: <DevicesIcon />,
      path: "/devices",
    },
    {
      text: "menu.reports",
      icon: <AssessmentIcon />,
      path: "/reports",
    },
    {
      text: "menu.stocks",
      icon: <Inventory2Icon />,
      path: "/stock-management",
    },
    {
      text: "menu.adminConfigurations",
      icon: <AdminPanelSettingsIcon />,
      path: "/admin-configurations",
      requiresAdmin: true,
    },
  ],

  DEFAULT: [
    {
      text: "menu.dashboard",
      icon: <HomeRoundedIcon />,
      path: "/dashboard",
    },
    {
      text: "menu.nodeDetail",
      icon: <PointOfSaleIcon />,
      path: "/vending-machines",
    },
    {
      text: "menu.regions",
      icon: <TravelExploreIcon />,
      path: "/regions",
    },
    {
      text: "menu.vending-definitions", // Varsayılan tenant için - Otomatlar
      icon: <PinDropIcon />,
      path: "/vending-definitions",
    },
    {
      text: "menu.users",
      icon: <PeopleIcon />,
      path: "/users",
      requiresAdmin: true,
    },
    {
      text: "menu.devices",
      icon: <DevicesIcon />,
      path: "/devices",
    },
    {
      text: "menu.reports",
      icon: <AssessmentIcon />,
      path: "/reports",
    },
    {
      text: "menu.stocks",
      icon: <Inventory2Icon />,
      path: "/stock-management",
    },
    {
      text: "menu.adminConfigurations",
      icon: <AdminPanelSettingsIcon />,
      path: "/admin-configurations",
      requiresAdmin: true,
    },
  ],
};

/**
 * Get menu configuration for specific tenant
 * @param {string} projectCode - Project code of tenant
 * @returns {Array} Menu items for tenant
 */
export const getTenantMenuConfig = (projectCode) => {
  const items =
    TENANT_MENU_CONFIGS[projectCode] ||
    TENANT_MENU_CONFIGS["DEFAULT"] ||
    TENANT_MENU_CONFIGS["VENDAI"];

  // Hide Users menu for non-superAdmin roles based on localStorage.userRoles
  let isSuperAdmin = false;
  try {
    const raw =
      typeof localStorage !== "undefined"
        ? localStorage.getItem("userRoles")
        : null;
    if (raw) {
      let parsed = raw;
      try {
        parsed = JSON.parse(raw);
      } catch (e) {
        // If not JSON, treat as plain string
      }

      if (Array.isArray(parsed)) {
        isSuperAdmin =
          parsed.includes("superAdmin") ||
          parsed.some(
            (r) => r?.name === "superAdmin" || r?.role === "superAdmin"
          );
      } else if (typeof parsed === "object" && parsed !== null) {
        const roles = parsed.roles || parsed.userRoles || [];
        if (Array.isArray(roles)) {
          isSuperAdmin =
            roles.includes("superAdmin") ||
            roles.some(
              (r) => r?.name === "superAdmin" || r?.role === "superAdmin"
            );
        }
      } else if (typeof parsed === "string") {
        const tokens = parsed.split(/[\s,;]+/).filter(Boolean);
        isSuperAdmin = tokens.includes("superAdmin") || parsed === "superAdmin";
      }
    }
  } catch (e) {
    isSuperAdmin = false;
  }

  return isSuperAdmin ? items : items.filter((item) => item?.path !== "/users");
};
